import React from 'react';
import { Modal, Switch } from 'antd';
import { CopySpan, DataGrid, Label, Loading, ScreenMask, message } from 'components/common';
import { HTTP_STATUS_OK, LOADING_ICON_SIZE1 } from 'constants/config';
import { fetchProductSerialNumberList, updateProductSerialNumber } from 'services/product';

type Props = {
  onClose: Function;
  product: StringKAnyVPair;
  updateProduct: Function;
  visible: boolean;
};

const SerialNumberDialog = (props: Props) => {
  const DEFAULT_GRID_PAGE_SIZE = 20;
  const { useRef, useState } = React;
  const [enableSerialNumber, setEnableSerialNumber] = useState(false);
  const [gridCount, setGridCount] = useState(0);
  const [inited, setInited] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [snList, setSnList] = useState<StringKAnyVPair[]>([]);
  const gridPageIndex = useRef<number>(0);
  const gridPageSize = useRef<number>(DEFAULT_GRID_PAGE_SIZE);

  const columns = [
    {
      header: 'SKU',
      name: 'sku',
      render(value: any) {
        const { data } = value;

        return (
          <CopySpan
            inGrid
            value={data.sku || ''}
          />
        );
      },
    },
    {
      header: 'Serial Number',
      name: 'serialNumber',
      render(value: any) {
        const { data } = value;

        return (
          <CopySpan
            inGrid
            value={data.serialNumber || ''}
          />
        );
      },
    },
  ];

  // eslint-disable-next-line
  const loadProductSerialNumberList = async () => {
    const params = {
      $count: 'true',
      $skip: gridPageIndex.current,
      $sortBy: 'serialNumber desc',
      $top: gridPageSize.current,
      //$filter
    };

    //console.log(props.product);
    setIsLoading(true);
    try {
      const { count, data } = await fetchProductSerialNumberList(props.product.productId, params) as any;

      if (Array.isArray(data)) {
        setGridCount(count || 0);
        //setGridCount(count + 1000);
        setSnList(data);
      }
    } catch(e) {
      message.error(`Fetched serial number list error: ${e}`);
    } finally {
      setIsLoading(false);
    }
  };

  const onChangeEnableSerialNumber = async (chk: boolean) => {
    if (chk === enableSerialNumber) return;

    setIsLoading(true);
    setEnableSerialNumber(chk);
    try {
      const { code, isSuccess } = await updateProductSerialNumber(props.product.productId, chk) as any;

      if (code === HTTP_STATUS_OK) {
        if (isSuccess) {
          const ud = {
            //'enableSerialNumber': chk ? 1 : 0,
            'recheckSerialNumber': chk ? 1 : 0,
          };

          props.updateProduct(ud);
        } else {
          setEnableSerialNumber(!chk);
        }
      } else {
        setEnableSerialNumber(!chk);
      }
    } catch(e) {
      setEnableSerialNumber(!chk);
      message.error(`${chk ? 'Enable' : 'Disable'} the serial number error: ${e}`);
    } finally {
      setIsLoading(false);
    }
  };

  const onClose = () => {
    props.onClose();
  };

  const onLimitChange = (limit: number) => {
    //gridRef?.current.deselectAll();
    if (gridPageSize.current !== limit) {
      if (gridPageIndex.current * limit >= gridCount) gridPageIndex.current = 0;

      gridPageSize.current = limit;
      loadProductSerialNumberList();
    }
  };

  const onSkipChange = (skip: number) => {
    const idx = skip / gridPageSize.current;
    //gridRef?.current.deselectAll();
    //console.log('s', skip, idx);
    if (gridPageIndex.current !== idx) {
      gridPageIndex.current = idx;
      loadProductSerialNumberList();
    }
  };

  React.useEffect(() => {
    if (!inited) {
      loadProductSerialNumberList();
      //setEnableSerialNumber(props.product.enableSerialNumber === 1);
      setEnableSerialNumber(props.product.recheckSerialNumber === 1);
      setInited(true);
    }
  }, [inited, loadProductSerialNumberList, props]);

  return (<>
    <Modal
      centered
      destroyOnClose={true}
      footer={null}
      maskClosable={false}
      onCancel={onClose}
      title="Serial Number"
      visible={props.visible}
      width={900}
    >
      <div>
        <div>
          <Label className="tail-colon2">Use Serial Number</Label>
          <Switch
            checked={props.product.enableSerialNumber}
            checkedChildren="Yes"
            disabled
            unCheckedChildren="No"
            //onChange={onChangeEnableSerialNumber}
          />
        </div>
        <div style={{marginTop: 12}}>
          <Label className="tail-colon2">Recheck Serial Number</Label>
          <Switch
            checked={enableSerialNumber}
            checkedChildren="Yes"
            unCheckedChildren="No"
            onChange={onChangeEnableSerialNumber}
          />
        </div>
        <div style={{marginTop: 12}}>
          <DataGrid
            columns={columns}
            count={gridCount}
            dataSource={snList}
            limit={gridPageSize.current}
            onLimitChange={onLimitChange}
            onSkipChange={onSkipChange}
            pageSizes={[20, 50, 100, 200]}
            pagination
            rowKey="id"
            style={{height: 'calc(100vh - 300px)', maxHeight: 700}}
          />
        </div>
      </div>
    </Modal>
    {isLoading && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default SerialNumberDialog;
